import dayjs from 'dayjs';
import { getCompany } from 'helpers/getCompanyVariables';
import { getStateCodeFromStateName } from 'helpers/states';

const isOneill = getCompany() === 'oneill';

export const FFM_CERTIFICATION_BLOCK_MESSAGE =
  'In order to request marketplace appointments, you must have a valid and active FFM certificate. It appears you do not have an active FFM certificate in place.';

/** State Based Exchange states; every other US state code is a Federally Facilitated Marketplace (FFM) state. */
export const SBE_STATES = [
  'WA',
  'OR',
  'NM',
  'AR',
  'PA',
  'NY',
  'ME',
  'ID',
  'CA',
  'NV',
  'CO',
  'MN',
  'IL',
  'KY',
  'GA',
  'VA',
  'MA',
  'CT',
  'RI',
  'VT',
  'NJ',
  'MD',
  'DC'
];

const SBE_STATE_CODES = new Set(SBE_STATES);

export function isMarketplaceCarrierType(carrierType) {
  return carrierType === 'Marketplace';
}

/**
 * True for states run through the federal marketplace (anything that is not an SBE state).
 * @param stateNameOrCode - full state name (`'California'`) or 2-letter code (`'CA'`)
 */
export function isFfmState(stateNameOrCode) {
  if (!stateNameOrCode) return false;

  const value = String(stateNameOrCode).trim();
  const code =
    value.length === 2 ? value.toUpperCase() : getStateCodeFromStateName(value);

  // unknown states are not treated as FFM, so nothing is hidden by accident
  if (!code) return false;

  return !SBE_STATE_CODES.has(code);
}

/**
 * @param {string|null|undefined} expirationDate - `YYYY-MM-DD` from user profile
 * @returns {boolean} true when missing, invalid, or before today (today/future are valid)
 */
export function isFfmCertificationExpiredOrMissing(expirationDate) {
  if (expirationDate == null || String(expirationDate).trim() === '') {
    return true;
  }

  const expiration = dayjs(String(expirationDate).trim());
  if (!expiration.isValid()) {
    return true;
  }

  return expiration.startOf('day').isBefore(dayjs().startOf('day'));
}

/** FFM gate is O'Neill-only and applies only to Marketplace carriers (`carrierData.type`). */
export function shouldBlockForFfmCertification(carrierType, expirationDate) {
  return (
    isOneill &&
    isMarketplaceCarrierType(carrierType) &&
    isFfmCertificationExpiredOrMissing(expirationDate)
  );
}
